import { render } from "./PasivoExigibleCrearActualizarComponent.vue?vue&type=template&id=51a9dd45&scoped=true"
import script from "./PasivoExigibleCrearActualizarComponent.vue?vue&type=script&lang=js"
export * from "./PasivoExigibleCrearActualizarComponent.vue?vue&type=script&lang=js"

import "./PasivoExigibleCrearActualizarComponent.vue?vue&type=style&index=0&id=51a9dd45&scoped=true&lang=css"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a9dd45"]])

export default __exports__